import React, { useState } from 'react';
import Modal from 'react-modal';
import { digitNumber } from '../../components/funcs/funcs';
import './style.css'
import { selectListOrders, setListOrders } from './personalSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getOrders, setOrderArchive } from './personapi';

export function Visits(props) {
    function formatDateString(inputString) {
        const date = new Date(inputString);
        
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Месяцы в JavaScript начинаются с 0
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
      
        return `${day}.${month}.${year} ${hours}:${minutes}`;
      }
    
    const renderedListVisits = props.visits.map(visit => {
        return (
            <>
                <tr>
                    
                    
                    <td className='fs-13'>{visit.phone}</td>
                    <td className='fs-13'>{visit.email}</td>
                    <td className='fs-13'>{formatDateString(visit.datetime)}</td>
                </tr>
            </>
        )
    })

    

    return (
        <>
            
            <div>
                
                <table classname="table bg-w brd-r5 mt-4">
                    <thead>
                        <tr>
                            <th scope="col" className='fs-13'>Телефон</th>
                            <th scope="col" className='fs-13'>Email</th>
                            <th scope="col" className='fs-13'>Дата/время</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderedListVisits}                            
                    </tbody>
                </table>
            </div>
        </>
    )
}
